// Shared by App.js (route protection/redirects) and FormTopBar.js (logo click target)
// so both stay in sync without a circular import between them.
export const ROLE_DEFAULTS = { coo: '/dashboard', compliance: '/compliance', technology: '/it', hr: '/hr', finance: '/finance', payroll: '/payroll', employee: '/employee', admin: '/admin', ceo: '/employee' };
